export const ENTER_KEY = 'Enter';
export const viewMode = {
  DIALOG: 'dialog',
  CONTENT: 'content',
};

export const extraPrices = {
  FREE_COM_DOMAIN: 'free_com_domain',
  NO_DISCOUNTS: 'no_discounts',
};

export const mockedDomainsData = [
  { domain: 'example.com' },
  { domain: 'example.org' },
  { domain: 'example.net' },
  { domain: 'example.eu' },
  { domain: 'example.ua' },
  { domain: 'example.bar' },
  { domain: 'example.de' },
  { domain: 'example.it' },
  { domain: 'example.co' },
  { domain: 'example.shop' },
];
